export default {"src":"/_next/static/media/ellipse5.c4a39405.svg","height":176,"width":176,"blurWidth":0,"blurHeight":0};